export var DEFAULT_PROMO_MONTHS = 1;
export var PROMO_CONFIRM_DAYS = 40;
// Evaluated on every render rather than stored as a flag, so a promo that
// expires while the page, cart cookie or server cache is still alive stops applying.
export var getActivePromo = function (product, now) {
    if (now === void 0) { now = Date.now(); }
    var priceEUR = product.priceEUR, promoPriceEUR = product.promoPriceEUR, promoEndsAt = product.promoEndsAt;
    if (!promoPriceEUR || !promoEndsAt || !priceEUR)
        return null;
    if (promoPriceEUR <= 0 || promoPriceEUR >= priceEUR)
        return null;
    var endsAt = new Date(promoEndsAt);
    if (isNaN(endsAt.getTime()) || endsAt.getTime() < now)
        return null;
    return {
        price: promoPriceEUR,
        percent: Math.round((1 - promoPriceEUR / priceEUR) * 100),
        endsAt: endsAt,
    };
};
export var getEffectivePriceEUR = function (product, now) { var _a, _b; return (_b = (_a = getActivePromo(product, now)) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : product.priceEUR; };
export var formatEUR = function (price) {
    return new Intl.NumberFormat('bg-BG', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(price);
};
export var formatPromoDate = function (date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    return "".concat(dd, ".").concat(mm, ".").concat(date.getFullYear());
};
export var promoUntilLabel = function (promo, language) {
    return language === 'bg'
        ? "\u0434\u043E ".concat(formatPromoDate(promo.endsAt))
        : "until ".concat(formatPromoDate(promo.endsAt));
};
